import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import logo from '../../assets/img/logo/logo.png';

const Preloader = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [text, setText] = useState('');

  useEffect(() => {
    const fullText = "Welcome to CabandGo...";
    let currentIndex = 0;

    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 100);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => {
      clearInterval(typingInterval);
      clearTimeout(timer);
    };
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#000000',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Loading..."
          sx={{
            width: { xs: '150px', sm: '200px', md: '250px' },
            height: 'auto',
            marginBottom: '20px',
            animation: 'breath 2s ease-in-out infinite',
          }}
        />
        
        <Typography
          variant="h6"
          sx={{
            color: '#ffffff',
            fontFamily: 'monospace',
            borderRight: '2px solid #ff4800',
            paddingRight: '5px',
            animation: 'blink 0.7s infinite',
          }}
        >
          {text}
        </Typography>
        
        <style>
          {`
            @keyframes breath {
              0% {
                transform: scale(1);
                opacity: 0.3;
              }
              50% {
                transform: scale(1.08);
                opacity: 1;
              }
              100% {
                transform: scale(1);
                opacity: 0.3;
              }
            }
            @keyframes blink {
              0%, 50% { border-color: #ff4800; }
              51%, 100% { border-color: transparent; }
            }
          `}
        </style>
      </Box>
    );
  }

  return children;
};

export default Preloader;